import * as CryptoJS from 'crypto-js'

function _getkeyv(token) {
  const _key = CryptoJS.enc.Hex.parse(CryptoJS.MD5(token.substring(5, 15)).toString())
  const _iv = CryptoJS.enc.Hex.parse(CryptoJS.MD5(token.split('').reverse().join('').substring(5, 15)).toString())
  return {
    _key, _iv
  }
}

export default {
  md5String(str) {
    return CryptoJS.MD5(str).toString()
  },
  md5Token(str) {
    return CryptoJS.MD5(CryptoJS.MD5(str).toString()).toString()
  }



}



// WEBPACK FOOTER //
// ./src/plugins/axios/crypto.js